/* eslint-disable import/no-anonymous-default-export */
import { AlertAppID } from "../alerts";
import { AppStateRepeatAlert } from ".";
import { SortDirection } from "../types";
import {
  IRepeatAlertSettings,
  REPEAT_ALERT,
  RepeatAlertActionType,
} from "./types";
import { ResidentActivityType } from "../residentActivityPlan";

const initialState: AppStateRepeatAlert = {
  isLoading: undefined,
  nodeDataNew: {},
  settings: {
    searchValue: "",
    selectedNodeIds: [],
    sort: SortDirection.ASC,
  },
};

export default (
  state = initialState,
  action: RepeatAlertActionType
): AppStateRepeatAlert => {
  switch (action.type) {
    case REPEAT_ALERT.GET_NODE_SETTINGS_REQUEST:
    case REPEAT_ALERT.SET_NODE_SETTINGS_REQUEST: {
      return { ...state, isLoading: true };
    }
    case REPEAT_ALERT.GET_NODE_SETTINGS_FAILURE:
    case REPEAT_ALERT.SET_NODE_SETTINGS_FAILURE: {
      return { ...state, isLoading: false };
    }
    case REPEAT_ALERT.GET_NODE_SETTINGS_SUCCESS: {
      const data = action.payload;
      const dataParsed = {};
      Object.keys(data).map((key) => {
        dataParsed[key] = {
          ...data[key],
          notifications: data[key].notifications.filter(
            (el) =>
              [
                AlertAppID.WrongDevicePlacement,
                AlertAppID.PowerUnplugged,
                AlertAppID.EpilepsyDetection,
                AlertAppID.NoWiFi,
                ResidentActivityType.TOILET,
                ResidentActivityType.PATROL,
              ].indexOf(el) === -1
          ),
        };
        return null;
      });
      return {
        ...state,
        nodeDataNew: dataParsed,
        isLoading: false,
      };
    }
    case REPEAT_ALERT.SET_NODE_SETTINGS_SUCCESS_By_Sockets: {
      const { nodeIds, ...rest } = action.payload;
      const newData = { ...state.nodeDataNew };
      nodeIds.map((nodeId) => {
        newData[nodeId] = rest;
        return null;
      });
      return {
        ...state,
        nodeDataNew: newData,
        isLoading: false,
      };
    }

    case REPEAT_ALERT.SET_SETTINGS: {
      const newSettings = (action as IRepeatAlertSettings).payload;
      return { ...state, settings: { ...state.settings, ...newSettings } };
    }
    case REPEAT_ALERT.CHANGE_SELECTED: {
      const selectChangeId = action.payload;
      const selected = [...state.settings.selectedNodeIds];
      // eslint-disable-next-line eqeqeq
      if (selected.indexOf(selectChangeId) == -1) selected.push(selectChangeId);
      else selected.splice(selected.indexOf(selectChangeId), 1);
      return {
        ...state,
        settings: { ...state.settings, selectedNodeIds: selected },
      };
    }

    default:
      return state;
  }
};
